module.exports = ng.material.tooltip;